// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum SynchronizationState {
  StatusUnknown = -1,
  SyncNotNeeded = 0,
  SyncNeeded = 1,
  OfflineMode = 2,
}
